import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("AFM render error:", error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto max-w-lg rounded-xl border border-red-200 bg-red-50 p-8 text-center" data-testid="route-error-boundary">
          <h2 className="font-serif text-2xl font-bold text-black">Algo salió mal en esta sección</h2>
          <p className="mt-2 text-sm text-slate-600">Ocurrió un error al mostrar estos datos. Puedes reintentar sin perder tu sesión.</p>
          <button onClick={this.reset} className="mt-4 rounded-lg bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate-800" data-testid="error-boundary-retry">
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
